// components/sessions/SessionRatesSection.jsx
import React, { useEffect, useRef, useState } from 'react';
// Data
import { sessionRates } from '../../utils/data/SessionsData';

function SessionRatesSection() {

  return (
    <section className='grid w-full pt-12 text-center'>
      <div className='grid max-w-3xl place-self-center gap-6 p-6'>
        <h4
          className={`text-2xl md:text-3xl lg:text-5xl font-titleFont tracking-widest drop-shadow-lg neon_text_heavy_redpink text-center uppercase`}
        >
          Rates
        </h4>
        <ul className='grid gap-2 text-center list-disc list-inside'>
          {sessionRates.map((rate, index) => (
            <li key={index}>
              <strong>{rate.label}:</strong> {rate.price}
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}

export default SessionRatesSection;
